import { memo } from 'react';
import { GridColumnHeaders, GridRow } from '@mui/x-data-grid';

export const MemoizedRow = memo(GridRow);

export const MemoizedColumnHeaders = memo(GridColumnHeaders);
